export default () => ({
  shownEditorDialog: false,
  isCreated: true,
  grade: {},
  errors: {},
});
